import { render, staticRenderFns } from "./BaseNumericKeyOnlyInputAction.vue?vue&type=template&id=13a52f8f&scoped=true&"
import script from "./BaseNumericKeyOnlyInputAction.vue?vue&type=script&lang=ts&"
export * from "./BaseNumericKeyOnlyInputAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a52f8f",
  null
  
)

export default component.exports